import {HttpHeaders} from '@angular/common/http';
import {
  Configuration,
  GetCountersResponse,
  GetReportForServiceNumberBaselineResponse,
  GetReportForServiceNumberResponse,
  GetReportForUserBaselineResponse,
  GetReportForUserResponse,
  StatsticsServiceInterface
} from '@gt-api';
import {Observable, of} from 'rxjs';

export class StatsticsServiceStub implements StatsticsServiceInterface {
  defaultHeaders: HttpHeaders = new HttpHeaders();
  configuration: Configuration;

  getCounters1(
    name: string,
    id: number,
    organization?: string,
    login?: string,
    serviceType?: 'Normal' | 'Inbound' | 'Outbound',
    from?: string,
    to?: string,
    extraHttpRequestParams?: any
  ): Observable<GetCountersResponse> {
    return of({
      counters: [],
      code: 200,
      message: 'Ok',
      exception: null
    });
  }

  getReportForServiceNumberBaseline1(
    serviceNumber: string,
    cid: number,
    organization?: string,
    login?: string,
    reportType?: string,
    serviceType?: string,
    baseline?: string
  ): Observable<GetReportForServiceNumberBaselineResponse> {
    return of({
      entries: [
        {
          entityId: '0',
          counters: {
            '@type': 'QueueReportCounters',
            totalCalls: 20,
            answeredCalls: 10,
            aAbandonCalls: 9,
            connectTime: 0,
            ringingTime: 0,
            directCalls: 0,
            queuedCalls: 0,
            clickToCall: 2
          },
          timeIntervalActual: {
            start: null,
            end: null
          }
        }
      ],
      code: 200,
      message: 'Ok',
      exception: null
    });
  }

  getReportForUserBaseline1(
    reportLogin: string,
    organization?: string,
    login?: string,
    reportType?: string,
    serviceType?: string,
    baseline?: string
  ): Observable<GetReportForUserBaselineResponse> {
    return of({
      entries: [
        {
          entityId: '412151',
          counters: {
            '@type': 'AgentReportCounters',
            totalCalls: 18,
            answeredCalls: 7,
            agentBusyCalls: 0,
            noRepliedCalls: 0,
            congestedCalls: 0,
            aAbandonCalls: 0,
            connectTime: 0,
            transferedCalls: 0,
            timeLoggedIn: 730
          },
          timeIntervalActual: {
            start: null,
            end: null
          }
        }
      ],
      code: 200,
      message: 'Ok',
      exception: null
    });
  }

  getReportForUser1(
    organization?: string,
    login?: string,
    reportType?: string,
    serviceType?: string,
    reportLogin?: string,
    from?: string,
    to?: string,
    granularity?: string
  ): Observable<GetReportForUserResponse> {
    const data: any = {
      periods: [
        {
          timeIntervalIdeal: {start: 1514970060000, end: 1515056460000},
          statisticsEntries: [
            {
              entityId: '98453517',
              counters: {
                '@type': 'AgentReportCounters',
                totalCalls: 2,
                answeredCalls: 2,
                agentBusyCalls: 0,
                noRepliedCalls: 0,
                congestedCalls: 0,
                aAbandonCalls: 0,
                connectTime: 20,
                transferedCalls: 0,
                timeLoggedIn: 0
              },
              timeIntervalActual: {start: 1514970060000, end: 1515056460000}
            },
            {
              entityId: '98453518',
              counters: {
                '@type': 'AgentReportCounters',
                totalCalls: 2,
                answeredCalls: 1,
                agentBusyCalls: 0,
                noRepliedCalls: 0,
                congestedCalls: 0,
                aAbandonCalls: 0,
                connectTime: 10,
                transferedCalls: 0,
                timeLoggedIn: 0
              },
              timeIntervalActual: {
                start: null,
                end: null
              }
            }
          ]
        }
      ],
      code: 200,
      message: 'Ok',
      exception: null
    };
    return of(data);
  }

  getReportForServiceNumber1(
    organization?: string,
    login?: string,
    reportType?: string,
    serviceType?: string,
    serviceNumber?: string,
    cid?: number,
    from?: string,
    to?: string,
    granularity?: string
  ): Observable<GetReportForServiceNumberResponse> {
    const data: any = {
      periods: [
        {
          timeIntervalIdeal: {start: 1514970060000, end: 1515056460000},
          statisticsEntries: [
            {
              entityId: '0',
              counters: {
                '@type': 'QueueReportCounters',
                totalCalls: 7,
                answeredCalls: 3,
                aAbandonCalls: 5,
                connectTime: 0,
                ringingTime: 0,
                directCalls: 0,
                queuedCalls: 1,
                clickToCall: 1
              },
              timeIntervalActual: {start: 1514970060000, end: 1515056460000}
            },
            {
              entityId: '0',
              counters: {
                '@type': 'QueueReportCounters',
                totalCalls: 2,
                answeredCalls: 1,
                aAbandonCalls: 1,
                connectTime: 5,
                ringingTime: 0,
                directCalls: 0,
                queuedCalls: 1,
                clickToCall: 1
              },
              timeIntervalActual: {start: 1514970060000, end: 1515056460000}
            },
            {
              entityId: '1',
              counters: {
                '@type': 'QueueReportCounters',
                totalCalls: 5,
                answeredCalls: 2,
                aAbandonCalls: 4,
                connectTime: 0,
                ringingTime: 0,
                directCalls: 0,
                queuedCalls: 0,
                clickToCall: 0
              },
              timeIntervalActual: {start: 1514970060000, end: 1515056460000}
            }
          ]
        }
      ],
      code: 200,
      message: 'Ok',
      exception: null
    };
    return of(data);
  }
}
